<div class="ai-chatbot-loading">
  <div
    class="ai-chatbot-loading-interpreting"
    *ngIf="!aiChatbotService.interpretationResponse && !aiChatbotService.isLoadingTemplates"
  >
    <div class="ai-chatbot-loading-interpreting-glow"></div>
    <span class="ai-chatbot-loading-interpreting-text">Thinking...</span>
  </div>

  <div
    class="ai-chatbot-loading-generating"
    *ngIf="aiChatbotService.interpretationResponse?.loadingMessage || aiChatbotService.isLoadingTemplates"
  >
    <div
      class="ai-chatbot-loading-generating-stars-container"
      aria-hidden="true"
    >
      <mat-icon
        svgIcon="ai-chatbot-star-loading"
        class="ai-chatbot-loading-generating-icon ai-chatbot-loading-generating-icon-1"
        aria-hidden="true"
      ></mat-icon>
      <mat-icon
        svgIcon="ai-chatbot-star-loading"
        class="ai-chatbot-loading-generating-icon ai-chatbot-loading-generating-icon-2"
        aria-hidden="true"
      ></mat-icon>
      <mat-icon
        svgIcon="ai-chatbot-star-loading"
        class="ai-chatbot-loading-generating-icon ai-chatbot-loading-generating-icon-3"
        aria-hidden="true"
      ></mat-icon>
    </div>
    <span
      class="ai-chatbot-loading-generating-text"
      role="status"
      aria-live="polite"
    >
      {{ aiChatbotService.interpretationResponse?.loadingMessage }}
    </span>
  </div>

  <div
    #samplesContainer
    class="ai-chatbot-loading-generating-samples-row"
    *ngIf="
      aiChatbotService.interpretationResponse?.type ===
      'generating_presentations' || aiChatbotService.isLoadingTemplates
    "
  >
    <div
      class="ai-chatbot-loading-generating-sample"
      *ngIf="shownSamples >= 1"
      [@fadeIn]
    >
      <ng-container *ngTemplateOutlet="loadingState3PresentationGlow">
      </ng-container>
    </div>
    <div
      class="ai-chatbot-loading-generating-sample"
      *ngIf="shownSamples >= 2"
      [@fadeIn]
    >
      <ng-container *ngTemplateOutlet="loadingState3PresentationGlow">
      </ng-container>
    </div>
    <div
      class="ai-chatbot-loading-generating-sample"
      *ngIf="shownSamples >= 3"
      [@fadeIn]
    >
      <ng-container *ngTemplateOutlet="loadingState3PresentationGlow">
      </ng-container>
    </div>
  </div>
</div>

<ng-template #loadingState3PresentationGlow>
  <svg
    class="ai-chatbot-loading-generating-sample-glow"
    width="224"
    height="224"
    viewBox="0 0 199 112"
    fill="none"
  >
    <g filter="url(#filter0_f_700_20962)">
      <ellipse
        cx="95"
        cy="134"
        rx="94"
        ry="93"
        transform="rotate(90 95 134)"
        fill="#92E7FF"
      />
      <circle
        cx="98.5"
        cy="161.015"
        r="61"
        transform="rotate(90 98.5 161.015)"
        fill="#BEFFC8"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_700_20962"
        x="-98"
        y="-120"
        width="386"
        height="448"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="50"
          result="effect1_foregroundBlur_700_20962"
        />
      </filter>
    </defs>
  </svg>
</ng-template>
